export default __webpack_public_path__ + "static/media/play_store.858ed16b.svg";